import { render, staticRenderFns } from "./Featured_tx_left.vue?vue&type=template&id=854981d8&scoped=true&"
import script from "./Featured_tx_left.vue?vue&type=script&lang=js&"
export * from "./Featured_tx_left.vue?vue&type=script&lang=js&"
import style0 from "./Featured_tx_left.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Featured_tx_left.vue?vue&type=style&index=1&id=854981d8&scoped=true&lang=css&"
import style2 from "./Featured_tx_left.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854981d8",
  null
  
)

component.options.__file = "Featured_tx_left.vue"
export default component.exports